import {StoreAction} from '@/store/actions';
import {RouterContext} from '@/router/router-context';
import {UserRole} from '@/types/user-role';
import router from '@/router';
import {RoutsData} from '@/router/routs';

/**
 * Обновление информации о пользователе
 */
export default function isAdmin({to, next, store}: RouterContext) {
  if (store.getters.currentUser.role == UserRole.USER) {
    router.push({name: RoutsData.DEFAULT.name});
  } else {
    next();
  }
}
